import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-modifier-code-edit-modal',
  templateUrl: './modifier-code-edit-modal.component.html',
  styleUrls: ['./modifier-code-edit-modal.component.css']
})
export class ModifierCodeEditModalComponent implements OnInit {
  @Input() modifierCode: any;
  @Output() onCloseModal = new EventEmitter<string>();
  @Output() onSave = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  onSaveModifierCode(evt: any) {
    this.onSave.emit(evt);
  }

  closeModal() {
    this.onCloseModal.emit();
  }
}
